<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <Announcement type="netbill" />
            <v-card color="#80DEEA" elevation="0" height="120px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-file-table</v-icon>
                    &nbsp;Net Bill
                </v-card-title>
            </v-card>
            <v-card-subtitle><v-icon>mdi-information-outline</v-icon>&nbsp;Please click on the printer icon on the right if you wish to print this bill.</v-card-subtitle>
            <v-card-text>
                <span style="float: right;">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="printDoc"
                            >
                                <v-icon color="#80DEEA">
                                    mdi-printer
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Print this summary</span>
                    </v-tooltip>
                </span>
                <NetTuitionBill id="netbill" />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Announcement from "../../../components/Student/Announcements/Announcement.vue"
import NetTuitionBill from "../../../components/Student/Documents/NetTuitionBill.vue"

export default {
    components: {
        Announcement,
        NetTuitionBill
    },
    methods: {
        printDoc(){
            //Only Prints <NetTuitionBill /> element
            let e = document.getElementById("netbill").cloneNode(true);
            document.body.appendChild(e);
            e.classList.add("printable");
            
            setTimeout(function() {
                window.print();
                
                document.body.removeChild(e);
            }, 300);
        }
    }
}
</script>
<style>/* Make sure it is not scoped! */
@media print {
    body *:not(.printable, .printable *) {
        display: none;
    }
}
</style>